import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TrendingUp, TrendingDown, Info } from "lucide-react";
import api from "@/lib/api";

export function Ticker() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => api.get("/public/ticker").then(({ data }) => setItems(data.items)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  if (!items.length) return null;
  const row = [...items, ...items];
  return (
    <div className="bg-bb-surface border-y border-bb-gold/20 flex items-stretch overflow-hidden" data-testid="live-ticker">
      <a href="/methodology" data-testid="ticker-credibility-badge"
        className="shrink-0 z-10 flex items-center gap-1.5 px-3 bg-[#0F2145] border-r border-bb-gold/30 text-[10px] font-semibold uppercase tracking-[0.14em] text-bb-gold hover:bg-[#16294F] transition-colors">
        <Info size={12} /> VDR Data
      </a>
      <div className="bb-marquee py-2 flex-1">
        {row.map((it, i) => {
          const color = it.dir === "down" ? "#8B3A3A" : it.dir === "up" ? "#4A7C59" : "#9C9189";
          const Icon = it.dir === "down" ? TrendingDown : it.dir === "up" ? TrendingUp : null;
          return (
            <span key={`${it.label}-${i}`} onClick={() => it.href && nav(it.href)}
              data-testid={`ticker-item-${i % items.length}`}
              className={`inline-flex items-center gap-2 px-7 text-sm tnum tracking-wide ${it.href ? "cursor-pointer hover:opacity-75 transition-opacity" : ""}`}>
              <span className="text-bb-muted uppercase text-[11px] tracking-[0.16em]">{it.label}</span>
              <span className="text-bb-text font-medium">{it.value}</span>
              <span className="inline-flex items-center gap-0.5" style={{ color }}>
                {Icon && <Icon size={12} />}{it.change}
              </span>
              <span className="text-bb-gold/30">◆</span>
            </span>
          );
        })}
      </div>
    </div>
  );
}
